import React, {useContext} from 'react';
import {AdBlockDetectedWrapper} from "adblock-detect-react";
import Modal, {ModalHeader, ModalBody, ModalButtonsContainer, ModalButton} from '../../../lib/ui/v1/Modal';
import {SignupSheetContext} from '../../context';

const AdBlockModal = () => {
  const {sheet: {showAds, belongsToCurrentUser}} = useContext(SignupSheetContext);
  const show = showAds && !belongsToCurrentUser;
  return (
    <AdBlockDetectedWrapper>
      <Modal
        show={show}
        onClose={() => {}}
      >
        <ModalHeader>Ad Blocker Detected</ModalHeader>
        <ModalBody>
          <p>It looks like you're using an ad blocker. </p>
          <p>To access this signup sheet, please disable it and refresh the page.</p>
        </ModalBody>
        <ModalButtonsContainer>
          <ModalButton onClick={() => window.location.reload()}>Refresh</ModalButton>
        </ModalButtonsContainer>
      </Modal>
    </AdBlockDetectedWrapper>
  );
};

export default AdBlockModal;
